const maping = {
  loadpage: {
    title: 'Download GamesToday',
    metaTags: [{
            name: 'keywords',
            content: 'download gamestoday',
        }, {
            name: 'description',
            content: 'The lasted GamesToday can make it easier to download games',
        }],
    keepAlive: true    //开启缓存
  },
  HelloWorld: {
    title: 'GamesToday官网-GamesToday官方版下载',
    keepAlive: true,    //开启缓存
    metaTags: [{
            name: 'keywords',
            content: 'GamesToday官网,GamesToday官方版',
        }, {
            name: 'description',
            content: 'GamesToday是一款专为玩家提供Google Play正版手机游戏下载平台，GamesToday官网专注于谷歌商店精品热门游戏一网打尽，资源全，内容多，实时更新，欢迎各位玩家前来下载，解锁更多新鲜游戏。',
        }]
  },
  details: {
    title: '{}-GamesToday',
    metaTags: [{
        name: 'keywords',
        content: '',
    }, {
        name: 'description',
        content: '',
    }]
  },
  search: {
    title: 'Search for『』- GamesToday',
    metaTags: [{
        name: 'keywords',
        content: '',
    }, {
        name: 'description',
        content: '',
    }]
  },
  saleAll: {
    title: 'Discount games - GamesToday',
    metaTags: [{
        name: 'keywords',
        content: '',
    }, {
        name: 'description',
        content: '',
    }],
    keepAlive: true    //开启缓存
  },
  errorPage: {
    title: '404-Page not found',
    metaTags: [{
        name: 'keywords',
        content: '',
    }, {
        name: 'description',
        content: '',
    }],
  }
}

export default maping



// WEBPACK FOOTER //
// ./src/TDK/mate.js